<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  >
    <div id="map-container" class="pa-4" style="width: 100%;height: 800px;"></div>
      <div id="popup" class="ol-popup">
        <a href="#" id="popup-closer" class="ol-popup-closer"></a>
        <div id="popup-content"></div>
    </div>

    <table class="legend_table">
      <tbody>
        <tr class="legend_row">
          <td class="legend_cell"><div class="legend_color" style="border: none;margin-right: 5px;background-color: rgba(60, 222, 103, 0.5);"></div><div class="legend_label">{{ $t('School') }}</div></td>
          <!--<td class="legend_cell"><div class="legend_color" style="border: none;margin-right: 5px;background-color: rgb(220, 20, 60, 0.5);"></div><div class="legend_label">{{ $t('Hospital') }}</div></td>
          <td class="legend_cell"><div class="legend_color" style="height: 1px;margin-right: 5px;border:1px solid #e67300;background-color: #e67300;"></div><div class="legend_label">{{ $t('Road') }}</div></td>-->
        </tr>        
      </tbody>
    </table>

  </v-container>
</template>

<script>

  import 'ol/ol.css';
  import GeoJSON from 'ol/format/GeoJSON';
  import Map from 'ol/Map';
  import View from 'ol/View';
  import {fromLonLat/*, toLonLat*/} from 'ol/proj';
  import VectorSource from 'ol/source/Vector';
  import VectorLayer from 'ol/layer/Vector';
  import TileLayer from 'ol/layer/Tile';
  import { Fill, Stroke, Style, Text, Icon } from 'ol/style';
  import { defaults as defaultInteractions, MouseWheelZoom, DoubleClickZoom, DragPan } from 'ol/interaction';
  
  import laosData from '@/assets/laoPDR.json';
  import roadData from '@/assets/roads_osm.json';
  //import picture from '@/assets/roadworks.png';

  import Feature from 'ol/Feature';
  import Overlay from 'ol/Overlay';
  import Point from 'ol/geom/Point';
  import Circle from 'ol/geom/Circle';

  //import {toStringHDMS} from 'ol/coordinate';

  export default {
    name: 'AssetMgtTable',
    data: () => ({
    }),
    mounted: function() {

      /**
       * Elements that make up the popup.
       */
      const container = document.getElementById('popup');
      const content = document.getElementById('popup-content');
      const closer = document.getElementById('popup-closer');

      /**
       * Create an overlay to anchor the popup to the map.
       */
      const overlay = new Overlay({
        element: container,
        autoPan: {
          animation: {
            duration: 250,
          },
        },
      });

      /**
       * Add a click handler to hide the popup.
       * @return {boolean} Don't follow the href.
       */
      closer.onclick = function () {
        overlay.setPosition(undefined);
        closer.blur();
        return false;
      };

      //PROVINCE LAYER
      var laosSource = new VectorSource({
        features: new GeoJSON().readFeatures(laosData),
        format: new GeoJSON(),
        crossOrigin: 'anonymous'
      });

      var laosLayer = new VectorLayer({
        renderMode: 'image',
        source: laosSource,
        style: styleLaosFunction
      });

      // the style function returns an array of styles for the given feature and resolution.
      // Return null to hide the feature.
      function styleLaosFunction(feature, resolution) {
        var style = new Style({
          fill: new Fill({
            color: 'white'
          }),
          stroke: new Stroke({
            color: '#DCDCDC',
            width: 1,
          })
        });
        return [style];
      }

      //ROAD LAYER
      var roadSource = new VectorSource({
        features: new GeoJSON().readFeatures(roadData),
        format: new GeoJSON(),
        crossOrigin: 'anonymous'
      });

      var roadLayer = new VectorLayer({
        renderMode: 'image',
        source: roadSource,
        style: styleRoadFunction
      });

      var defaultStyle = new Style({
        fill: new Fill({
          color: '#e67300',
        }),
        stroke: new Stroke({
          color: '#e67300',
          width: 1,
        })
      });

      // the style function returns an array of styles for the given feature and resolution.
      // Return null to hide the feature.
      function styleRoadFunction(feature, resolution) {
        return [defaultStyle];
      }

      var transparentLayerSource = new VectorSource({
        features: new GeoJSON().readFeatures(laosData),
        format: new GeoJSON(),
        crossOrigin: 'anonymous'
      });

      var transparentLayer = new VectorLayer({
        renderMode: 'image',
        source: transparentLayerSource,
        style: styleTransparentFunction
      });

      function styleTransparentFunction(feature, resolution) {

        return [
          new Style({
              fill: new Fill({
                color: '#ff000000'
              }),
              stroke: new Stroke({
                color: '#ff000000',
                width: 1,
              })
            })
        ];

      }

      //SCHOOL LAYER
      const iconSchoolSource = new VectorSource({
        features: [],
      });

      const iconSchoolLayer = new VectorLayer({
        source: iconSchoolSource,
      });

      //for(let i = 0; i < stationLocation.length; i++){

        const iconSchoolFeature = new Feature({
          geometry: new Point([ 104.8, 16.6 ]/*fromLonLat( [ 20.329, 100.192 ] , "EPSG:4326", "EPSG:3857")*/),
          id: /*i+*/1,
          name: 'Savannakhet'
        });
        const iconSchoolStyle = new Style({
          text: new Text({
                 text: '1', //stationLocation[i][3],
                 font: 'bold 17px Calibri,sans-serif',
                 fill: new Fill({ color: 'black' }),
                 color: '#fff', 
                 width: 2,
                 textAlign: 'center',
                 textBaseline: 'hanging',               
                 offsetX : 0,
                 offsetY : -5,           
                 declutter: true,
                 overflow: true
         })
        });
        iconSchoolFeature.setStyle(iconSchoolStyle);
        iconSchoolLayer.getSource().addFeature(iconSchoolFeature);

        //for(let j =0; j < stationLocation.length; j++) {
            const circleShoolLayer = new VectorLayer({
              source: new VectorSource({
              features: [new Feature(new Circle([ 104.8, 16.6 ],0.15))]
            }),
              style: [
                      new Style({
                        stroke: new Stroke({
                          color: 'rgba(60, 222, 103, 1)',
                          width: 1
                        }),
                        fill: new Fill({
                          color: 'rgba(60, 222, 103, 0.5)'
                        })
                      })
                    ]
              }); 
        //}
      //}


      //Hospital LAYER
      /*const iconHospitalSource = new VectorSource({
        features: [],
      });

      const iconHospitalLayer = new VectorLayer({
        source: iconHospitalSource,
      });

      //for(let i = 0; i < stationLocation.length; i++){

      const iconHospitalFeature = new Feature({
        geometry: new Point([102.2, 19.9]),
        name: 'Luang Prabang'
      });
      const iconHospitalStyle = new Style({
        text: new Text({
               text: '1',
               font: 'bold 17px Calibri,sans-serif',
               fill: new Fill({ color: 'black' }),
               color: '#fff', 
               width: 2,
               textAlign: 'center',
               textBaseline: 'hanging',               
               offsetX : 0,
               offsetY : -5,           
               declutter: true,
               overflow: true
       })
      });
      iconHospitalFeature.setStyle(iconHospitalStyle);
      iconHospitalLayer.getSource().addFeature(iconHospitalFeature);

      const circleHospitalLayer = new VectorLayer({
        source: new VectorSource({
          features: [new Feature(new Circle([ 102.2, 19.9 ],0.15))]
        }),
        style: [
                new Style({
                  stroke: new Stroke({
                    color: 'rgb(220, 20, 60, 0.5)',
                    width: 1
                  }),
                  fill: new Fill({
                    color: 'rgb(220, 20, 60, 0.5)'
                  })
                })
              ]
      }); */

      //earthquakeMap.addLayer(iconEarthquakeLayer);





      var view = new View({
        center: fromLonLat([0.000933, 0.000164]),
        zoom: 23.5,
        /*minZoom: 23.9,
        maxZoom: 23.9*/
      });

      var map = new Map({
        target: 'map-container',
        layers: [
          laosLayer,
          roadLayer
        ],
        overlays: [overlay],
        view: view,
        /*interactions: defaultInteractions({
          mouseWheelZoom: false,
          doubleClickZoom: false,
          dragPan: false
        }).extend([])*/
      });

      map.addLayer(circleShoolLayer);
      //map.addLayer(circleHospitalLayer);

      map.addLayer(iconSchoolLayer);
      //map.addLayer(iconHospitalLayer);


      const marker = new Overlay({
        position: fromLonLat([0.0009246, 0.0001795]),
        positioning: 'center',
        element: document.getElementById('marker'),
        stopEvent: false,
      });
      map.addOverlay(marker);

      /**
       * Add a click handler to the map to render the popup.
       */
      map.on('singleclick', function (evt) {
        const coordinate = evt.coordinate;

        const pixel = evt.pixel;

        const feature = map.forEachFeatureAtPixel(pixel, function(feature) {
          return feature;
        });

        if(feature.get('name_en') === 'P. SAVANNAKHET'){

            content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
            content.innerHTML += '<p>School Affected:<span style="font-weight:bold;"> 1</span></p>';
            content.innerHTML += '<p>Name:<span style="font-weight:bold;"> Savannakhet University</span></p>';
            content.innerHTML += '<p>Disaster:<span style="font-weight:bold;"> Tropical Cyclone Dianmu</span></p>';

        }else{

            content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
            content.innerHTML += '<p>Asset Affected:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Name:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Disaster:<span style="font-weight:bold;"> /</span></p>';
        }


        overlay.setPosition(coordinate);
      });

      map.addLayer(transparentLayer);
   }
 }
</script>

<style>
  .row {
    margin: 0px;
  }
  .pd-0 {
    padding: 7px;
  }
  .v-application p {
      margin-bottom: 5px;
      font-size: 13px;
  }
  #information {
    display: flex;
    flex-direction: row;
    background-color: #ffffff;
    font-size: 10px;
    color: #212121;
    z-index: 100;
    position: relative;
    padding: 5px;
  }

  #marker {
    width: 20px;
    height: 20px;
    opacity: 1;
  }

  .ol-popup {
    position: absolute;
    background-color: white;
    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #cccccc;
    bottom: 12px;
    left: -50px;
    min-width: 280px;
  }
  .ol-popup:after, .ol-popup:before {
    top: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  .ol-popup:after {
    border-top-color: white;
    border-width: 10px;
    left: 48px;
    margin-left: -10px;
  }
  .ol-popup:before {
    border-top-color: #cccccc;
    border-width: 11px;
    left: 48px;
    margin-left: -11px;
  }
  .ol-popup-closer {
    text-decoration: none;
    position: absolute;
    top: 2px;
    right: 8px;
  }
  .ol-popup-closer:after {
    content: "✖";
  }

  .display_unit_label{
    position: fixed;
    left: 520px;
    bottom: 30px;
    padding: 1px 1px 1px 1px;
    z-index: 200;
    color: white;
    font-family: 'PT Sans',sans-serif;
    font-size: 15px;
    opacity: 1;
  }

  .legend_table {
    position: relative;
    left: 0px;
    /*bottom: 100px;*/
    z-index: 1;
    opacity: 1;
  }
  .legend_row {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
  .legend_cell {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .legend_color{
    border:1px solid grey;
    width: 14px;
    height: 14px;
    padding: 0;
    margin: 0;
  }
  .legend_label{
    font-size: 1.0625rem;
  }

</style>
